function Spinner() {
  return (
    <div className="d-flex justify-content-center">
      <div data-e2e="spinner" className="spinner spinner-sm" />
    </div>
  );
}

export default Spinner;
